import Button from '@ui/Button'
import Breadcrumb from '@common/Breadcrumb'
import {ROUTES,SITE } from '@/constants'
import TransformBanner from '@sections/TransformBanner'
 import { buildRows } from '../assets/js/common'
import MetaInfo from '@common/MetaInfo'
import { metaTitleFor } from '../assets/js/navBreadcrumb'
const { label, pageDesc, metaDesc } = metaTitleFor(ROUTES.DEVOPS)


 const MANAGEMNT_TASK = [
  { title: 'CI/CD & Deployment Automation',desc: 'Automate build, testing, deployment, and release processes to deliver application updates faster and with greater consistency.' },
  { title: 'Infrastructure Management',      desc: 'Manage servers, environments, configurations, networking, storage, and supporting infrastructure across on-premise and cloud environments.' },
  { title: 'Monitoring & Observability',           desc: 'Monitor application health, infrastructure performance, availability, resources, logs, and operational events to identify issues early.' },
  { title: 'Backup & Recovery',  desc: 'Implement appropriate backup strategies and recovery processes to protect critical applications and business data.' },
  { title: 'Security & Access Management', desc: 'Strengthen infrastructure security through access controls, secure configurations, patching, monitoring, and operational best practices.' },
  { title: 'Infrastructure Optimization',   desc: 'Review infrastructure usage and configurations to improve performance, reliability, availability, and operational efficiency.' },  
]


const AMC_MAINTENANCE  = [
   { name: 'Servers & Infrastructure',    color: { bg: '#f7d3cf', text: '#7a3228' } },
 
  { name: 'CI/CD Pipelines',     color: { bg: '#9bcf60', text: '#2e5a0e' } },
  { name: 'Application Environments',       color: { bg: '#7fc2eb', text: '#1a4f72' } },
 
  { name: 'Containers',     color: { bg: '#a9e5e5', text: '#1a5c5c' } },
  { name: 'Databases',   color: { bg: '#dbd1fc', text: '#4a2d8a' } },
  { name: 'Networks',           color: { bg: '#9bcf60', text: '#2e5a0e' } },
  { name: 'Monitoring',      color: { bg: '#dbd1fc', text: '#4a2d8a' }  },
  { name: 'Backups',       color: { bg: '#f7d3cf', text: '#7a3228' } },
  { name: 'Security Configurations',        color: { bg: '#9bcf60', text: '#2e5a0e' } },
  { name: 'Deployment Processes',         color: { bg: '#7fc2eb', text: '#1a4f72' }  },
]
  const AMC_MAINTENANCERows = buildRows(AMC_MAINTENANCE)

export default function DevOps() {
  

  return (
    <>
     {/* <MetaInfo
        title="DevOps & Infrastructure Management | CruxBytes"
        description="Improve application deployment, infrastructure reliability and operational efficiency with DevOps, CI/CD, monitoring and infrastructure management services."
        keywords="DevOps services, infrastructure management, CI/CD, deployment automation, monitoring, backup and recovery, CruxBytes"
      /> */} 
      <MetaInfo
     title={label}
      description={metaDesc}
      keywords=""
      />
      <main id="main-content" className="page-wrapper">
         <div className="page-hero">
           <div className="bg-grid bg-grid--fill" aria-hidden="true" />
           <div className="container">
             {/* <div className="section-label">- Maintenance & Support -</div> */}
              <Breadcrumb />
             <h1 data-aos="fade-up" data-aos-delay={100}>
              {/* DevOps & Infrastructure Management */}
              {label}
              </h1>
             <p className="page-subtitle" data-aos="fade-up" data-aos-delay={200}>
             {/* Accelerate software delivery with scalable DevOps strategies and automation. */}
             {pageDesc}
             </p>
            
             <div className="inner-page-actions">
               <Button  href={ROUTES.SALES_ENQUIRY}  variant="primary" icon="fa-arrow-right" iconPos="right" data-aos="fade-up" data-aos-delay={300}>
                 Get a Free Quote
               </Button>
              
             </div>
           </div>
         </div>
            {/* section 1 */}
                 <section className="bg-linear-gradient-light section-py" >
               <div className="container">
                  <p className="text-center" data-aos="fade-up" >
                      Modern applications need more than good code. They require reliable infrastructure, automated deployment processes, continuous monitoring, and efficient operational practices.
                     </p>
                     <p className="text-center" data-aos="fade-up">
                      CruxBytes helps organizations manage the technology environment behind their applications—from infrastructure provisioning and deployment automation to monitoring, security, backups, and ongoing optimization. We bring development and operations together to create smoother, more predictable software delivery and dependable application environments.
                     </p>
                 
                      <div className="wcs-grid wcs-grid--3 pt-4">
                   {MANAGEMNT_TASK.map((card, i) => (
                     <div
                       key={card.title}
                       className="wcs-card-offer wcs-card-offer-4"
                       data-aos="fade-up"
                       data-aos-delay={(i % 3) * 100}
                     >
                       {/* <i className={`${card.icon} wcs-icon`} aria-hidden="true" /> */}
                       <h3 className="wcs-offer-title">{card.title}</h3>
                       <p className="wcs-offer-desc">{card.desc}</p>
                     </div>
                   ))}
                 </div>
                 
               </div>
             </section>
         
         {/* section 2 */}
               <section className="section-py text-center"  aria-label="Investing in our people" data-aos="fade-up">
                 <div className="container">
                    
                 <div  data-aos="fade-up">
                   <h2>
                    Our Maintenance Coverage
                   </h2>
                 </div>  
                     <div className="domain-grid pb-4" aria-label="List of industries we serve">
                         {AMC_MAINTENANCERows.map((row, rowIdx) => (
                           <div key={rowIdx} className="domain-row">
                             {row.map((domain, chipIdx) => (
                               <span
                                 key={domain.name}
                                 className="domain-chip"
                                 style={{ '--chip-bg': domain.color.bg, '--chip-text': domain.color.text }}
                                 data-aos="fade-up"
                                 data-aos-delay={chipIdx * 30}
                               >
                                 {domain.name}
                               </span>
                             ))}
                           </div>
                         ))}
                       </div>
         <div className="pt-4" data-aos="fade-up">
                   <h5>
                    Infrastructure That Keeps Your Business Running
                   </h5>
                 </div> 
         
                     <p  data-aos="fade-up">
                      From managing an existing infrastructure environment to establishing a modern DevOps operating model, CruxBytes helps create technology operations that are stable, automated, observable, and ready to scale.
                     </p>
                  
                   </div>
                 </section>
         <TransformBanner />
         </main>

         </>
  )
}